import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { schedularAnnouncementActions } from 'src/redux/actions/constant';
import therapistService from 'src/services/apiServices/therapist-scheduling/therapistService';
const {
  CREATE_ANNOUNCEMENT_REQUEST,
  CREATE_ANNOUNCEMENT_SUCCESS,
  CREATE_ANNOUNCEMENT_FAILURE,
  GET_ALL_ANNOUNCEMENTS_REQUEST,
} = schedularAnnouncementActions;

function* createAnnouncement(action: any): SagaReturnType<any> {
  try {
    const response = yield call(therapistService.createAnnouncement, action.payload);
    if (response?.status === 200) {
      yield put({ type: CREATE_ANNOUNCEMENT_SUCCESS, payload: response.data });
      yield put({
        type: GET_ALL_ANNOUNCEMENTS_REQUEST,
        payload: { selectedDate: action.payload.date },
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: CREATE_ANNOUNCEMENT_FAILURE, payload: error });
  }
}

function* createAnnouncementSaga() {
  yield takeEvery(CREATE_ANNOUNCEMENT_REQUEST, createAnnouncement);
}

export default createAnnouncementSaga;
